// Codici sintetici generati dal nostro agente locale (non provengono dall'API Cashmatic),
// usati per segnalare condizioni che l'API stessa non può descrivere con un "code" numerico.
const SYNTHETIC_LABELS = {
	not_dispensed: "Importo non erogato",
	auth_error: "Errore di autenticazione sul dispositivo",
	connection_error: "Dispositivo non raggiungibile",
	poll_error: "Errore di comunicazione con il dispositivo",
	insufficient_amount: "Importo inserito insufficiente",
	// Segnale interno agente->POS: annullo concluso pulito. Non dovrebbe mai essere
	// renderizzato (il POS chiude subito il popup), etichetta solo di sicurezza.
	canceled: "Pagamento annullato",
};

export default function CashmaticErrorLabel({ code }) {
	if (!code) return null;

	function getLabel() {
		if (SYNTHETIC_LABELS[code]) return SYNTHETIC_LABELS[code];

		switch (parseInt(code)) {
			case 1:
				return "Richiesta sconosciuta";
			case 2:
				return "Parametri non validi";
			case 3:
				return "Impossibile elaborare il comando";
			case 4:
				return "Altra operazione attiva";
			case 5:
				return "Nessuna operazione attiva";
			case 6:
				return "Errore dispositivo";
			case 8:
				return "Nessuna denominazione disponibile";
			case 10:
				return "Database error";
			case 11:
				return "Utente non trovato";
			case 12:
				return "Password non valida";
			case 13:
				return "Dispositivo non attivo";
			case 14:
				return "Modulo non attivo";
			case 15:
				return "Dispositivo gia' attivo";
			default:
				return "Errore sconosciuto (" + code + ")";
		}
	}

	return getLabel();
}
